/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Action_ApproveInputs */

const vi_sl_detail_action_approve = /** @type {(inputs: Sl_Detail_Action_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt`)
};

/**

* @param {Sl_Detail_Action_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_action_approve = /** @type {((inputs?: Sl_Detail_Action_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Action_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_action_approve(inputs)
});